import { render, staticRenderFns } from "./PreguntasEmergenciaSection.vue?vue&type=template&id=0c6f8aac&scoped=true&"
import script from "./PreguntasEmergenciaSection.vue?vue&type=script&lang=js&"
export * from "./PreguntasEmergenciaSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6f8aac",
  null
  
)

export default component.exports